/** A point on the unit sphere, as x, y, z (z toward the north pole). */
export type Vec3 = [number, number, number]

export const RAD = Math.PI / 180

/** The unit-sphere point at a latitude and longitude, both in radians. */
export function unitVector(lat: number, lon: number): Vec3 {
  const cosLat = Math.cos(lat)
  return [cosLat * Math.cos(lon), cosLat * Math.sin(lon), Math.sin(lat)]
}

/** The angle in radians between two unit-sphere points. */
export function angleBetween(a: Vec3, b: Vec3): number {
  const dot = a[0] * b[0] + a[1] * b[1] + a[2] * b[2]
  return Math.acos(Math.min(1, Math.max(-1, dot)))
}
